const numericValidator = (input: string): boolean => /^\d+$/.test(input);

/**
 * Returns the failed validation message key, or '' when the zip code is valid.
 * Single source of truth for the zip-code rules.
 */
export const validateZipCodeSync = (value: string) => {
  const zipCodeValidations: [boolean, string][] = [
    [!value, 'VALIDATION_MESSAGE.ZIP_CODE_EMPTY'],
    [!numericValidator(value), 'VALIDATION_MESSAGE.ZIP_CODE_NUMERIC_INPUT'],
    [value.length < 5, 'VALIDATION_MESSAGE.ZIP_CODE_LESS_5DIGITS'],
    [value.length > 5, 'VALIDATION_MESSAGE.ZIP_CODE_MORE_5DIGITS'],
  ];

  return zipCodeValidations.find(([match]) => match)?.[1] ?? '';
};

export const isValidZipCode = (
  value: string | null | undefined
): value is string =>
  typeof value === 'string' && validateZipCodeSync(value) === '';

export const handleNumberInput = (
  e: React.KeyboardEvent<HTMLInputElement>,
  additionalKeys: string[] = []
) => {
  // Allow: backspace, delete, tab, escape, enter, decimal point
  const allowedKeys = [
    'Backspace',
    'Delete',
    'Tab',
    'Enter',
    'Escape',
    'ArrowLeft',
    'ArrowRight',
    'ArrowDown',
    'ArrowUp',
  ];

  // Allow number keys (0-9)
  const isNumber = /^[0-9]$/.test(e.key);

  // Block the key press if it's not allowed
  if (
    !isNumber &&
    !allowedKeys.includes(e.key) &&
    !additionalKeys.includes(e.key)
  ) {
    e.preventDefault();
  }
};

export const handleIntegerNumberInput = handleNumberInput;

export const handleDecimalNumberInput = (
  event: React.KeyboardEvent<HTMLInputElement>
): void => {
  handleNumberInput(event, ['.']);
};
